import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// 将页面中的路由都进行集成
export const constantRoutes = [
  // 采用路由懒加载方式
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: () => import('@/views/login'),
    meta: { title: '登录', standalone: true }
  },
  {
    path: '/sso',
    name: 'SSOLogin',
    hidden: true,
    component: () => import('@/views/login/SSOLogin.vue'),
    meta: { title: '统一登录授权', standalone: true, requiresAuth: true }
  },
  {
    path: '/',
    name: 'fcreen',
    hidden: true,
    component: () => import('@/views/index'),
    meta: { title: '首页' }
  },
  {
    path: '/ability',
    name: 'ability',
    hidden: true,
    component: () => import('@/views/ability'),
    meta: { title: '地图能力' },
    redirect: '/ability/integrated',
    children: [
      {
        path: 'threeDimensional',
        component: () => import('@/views/ability/threeDimensional.vue'),
        meta: { title: '三维地图' }
      },
      {
        path: 'twoDimensional',
        component: () => import('@/views/ability/twoDimensional.vue'),
        meta: { title: '二维地图' }
      },
      {
        path: 'integrated',
        component: () => import('@/views/ability/integrated.vue'),
        meta: { title: '二三维一体化' }
      },
      {
        path: 'tiltPhotography',
        component: () => import('@/views/ability/tiltPhotography.vue'),
        meta: { title: '倾斜摄影' }
      },
      {
        path: 'tfDimensional',
        component: () => import('@/views/ability/tfDimensional.vue'),
        meta: { title: '2.5维地图' }
      }
    ]
  },
  {
    path: '/solve',
    name: 'solve',
    hidden: true,
    component: () => import('@/views/solve'),
    meta: { title: '解决方案' },
    redirect: '/solve/city',
    children: [
      {
        path: 'city',
        component: () => import('@/views/solve/components/smartCity.vue'),
        meta: { title: '智慧城市' }
      },
      {
        path: 'tourism',
        component: () => import('@/views/solve/components/smartTourism.vue'),
        meta: { title: '美丽城镇' }
      },
      {
        path: 'town',
        component: () => import('@/views/solve/components/smartTowm.vue'),
        meta: { title: '智慧城市' }
      },
      {
        name: 'solve',
        path: 'village',
        component: () => import('@/views/solve/components/digitalVillage.vue'),
        meta: { title: '数字乡村' }
      },
      {
        name: 'solve',
        path: 'park',
        component: () => import('@/views/solve/components/smartPark.vue'),
        meta: { title: '智慧园区' }
      }
    ]
  },
  {
    path: '/case',
    name: 'case',
    hidden: true,
    component: () => import('@/views/case'),
    meta: { title: '客户案例' },
    redirect: '/case/smartVillage',
    children: [
      {
        path: 'wisdomCity',
        component: () => import('@/views/case/wisdomCity.vue'),
        meta: { title: '智慧城市' }
      },
      {
        path: 'globalTourism',
        component: () => import('@/views/case/globalTourism.vue'),
        meta: { title: '全域旅游' }
      },
      {
        path: 'smartSpot',
        component: () => import('@/views/case/smartSpot.vue'),
        meta: { title: '智慧景区' }
      },
      {
        path: 'beautifulTown',
        component: () => import('@/views/case/beautifulTown.vue'),
        meta: { title: '智慧城镇' }
      },
      {
        path: 'smartVillage',
        component: () => import('@/views/case/smartVillage.vue'),
        meta: { title: '数字乡村' }
      },
      {
        path: 'smartPark',
        component: () => import('@/views/case/smartPark.vue')
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    hidden: true,
    component: () => import('@/views/about'),
    meta: { title: '关于我们' }
  },
  // 404页面需要放到最末尾,先行注册404界面,否则无法指向404界面会报错
  {
    path: '/404',
    name: 'page404',
    hidden: true,
    component: () => import('@/views/404'),
    meta: { title: '404' }
  },
  // 指向页面错误跳转到404
  { path: '*', redirect: '/404', hidden: true }
];

// 创建一个vue-router 并且每次切换页面都调整滚动条的高度,并且存入固定路由界面
const createRouter = () =>
  new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition;
      } else {
        return savedPosition;
      }
    },
    routes: constantRoutes
  });

// 重置路由方法
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

const router = createRouter();
export default router;
